<script setup lang="ts">
import { StateMachineSnapshot, stateMachine } from '../stateMachine';
import FinishedStep from './steps/FinishedStep.vue';
import InstallHeadsetStep from './steps/InstallHeadsetStep.vue';
import PrepareInstallationStep from './steps/PrepareInstallationStep.vue';
import RecapInstallationStep from './steps/RecapInstallationStep.vue';
import SelectHeadsetStep from './steps/SelectHeadsetStep.vue';
import { useProgressStore } from '@/stores/progress.store';
import { createBrowserInspector } from '@statelyai/inspect';
import { useMachine } from '@xstate/vue';
import { onUnmounted } from 'vue';

const { isCustom } = defineProps<{ isCustom: boolean }>();

const progressStore = useProgressStore();

const { inspect } = createBrowserInspector({
  autoStart: false,
});

const { snapshot, send, actorRef } = useMachine(stateMachine, {
  inspect,
  input: {
    isCustom: isCustom,
  },
});

actorRef.subscribe({
  next: (snapshot: StateMachineSnapshot) => {
    progressStore.currentState = snapshot.value;
  },
  complete: async () => {
    // Force device release when component is unmounted
    if (snapshot.value.context.device) {
      await snapshot.value.context.device.releaseDevice();
    }
  },
});

onUnmounted(() => {
  // Remove subscription when component is unmounted
  actorRef.stop();
});
</script>

<template>
  <div class="form">
    <div v-if="snapshot.matches('closed')" class="cards">
      <em>Feedback form closed.</em>
      <br />
      <button @click="send({ type: 'restart' })">Provide more feedback</button>
    </div>
    <div v-else class="cards feedback">
      <div class="d-flex flex-column h-100">
        <div class="flex-grow-1">
          <SelectHeadsetStep v-if="snapshot.matches('selection')" :snapshot="snapshot" :send="send" />
          <PrepareInstallationStep v-if="snapshot.matches('prepare')" :snapshot="snapshot" :send="send" />
          <RecapInstallationStep v-if="snapshot.matches('recap')" :snapshot="snapshot" :send="send" />
          <InstallHeadsetStep v-if="snapshot.matches('clean')" :snapshot="snapshot" :send="send" step="reset" />
          <InstallHeadsetStep v-if="snapshot.matches('install')" :snapshot="snapshot" :send="send" step="install" />
          <InstallHeadsetStep v-if="snapshot.matches('validate')" :snapshot="snapshot" :send="send" step="verify" />
          <FinishedStep v-if="snapshot.matches('finished')" />
        </div>
        <div class="d-flex justify-content-end m-3">
          <button v-if="snapshot.can({ type: 'back' })" class="btn btn-secondary me-auto" @click="send({ type: 'back' })">Retour</button>
          <button
            v-if="!snapshot.matches('finished')"
            class="btn btn-primary"
            type="button"
            :disabled="!snapshot.can({ type: 'submit' })"
            @click="send({ type: 'submit' })"
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.form {
  overflow: hidden;
  display: grid;
  grid-template-columns: 0.5fr 2fr 0.5fr;
  grid-template-rows: 0.5fr 2fr 0.5fr;
  gap: 0px 0px;
  grid-template-areas:
    '. . .'
    '. cards .'
    '. . .';
  grid-area: form;
}

.cards {
  grid-area: cards;
  /* background-color: red; */
  border-radius: 1em;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
</style>
